import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home.vue'
import AboutUs from '@/page/AboutUs.vue'
import Product from '@/page/Product.vue'
import ProductList from '@/components/Product/ProductList.vue'
import Sample from '@/page/Sample.vue'
import Certification from '@/page/Certification.vue'
import News from '@/page/News.vue'
import NewList from '@/components/New/NewList.vue'
import NewsDetails from '@/components/New/NewsDetails.vue'
import ContactUs from '@/page/ContactUs.vue'
import Search from '@/page/Search.vue'
import Thanks from '@/page/Thanks.vue'
import ProductDetails from "@/components/Product/ProductDetails";

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    // savedPosition 的触发是在点击浏览器的前进和后退按钮
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/AboutUs*',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/Product*',
      name: 'Product',
      redirect: '/Product/ProductList',
      component: Product,
      children: [
        {
          path: '/Product/ProductList',
          name: 'ProductList',
          component: ProductList
        },
        {
          path: '/Product/ProductDetails',
          name: 'ProductDetail',
          component: ProductDetails,
        }
      ],
    },
    {
      path: '/Sample*',
      name: 'Sample',
      component: Sample
    },
    {
      path: '/Certification*',
      name: 'Certification',
      component: Certification
    },
    {
      path: '/News*',
      name: 'News',
      redirect: '/News/NewList',
      component: News,
      children: [
        {
          path: '/News/NewList',
          name: 'NewList',
          component: NewList
        },
        {
          path: '/News/NewsDetails',
          name: 'NewsDetails',
          component: NewsDetails,
        }
      ],
    },
    {
      path: '/ContactUs*',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/Search*',
      name: 'Search',
      component: Search
    },
    {
      path: '/Thanks*',
      name: 'Thanks',
      component: Thanks
    },
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js